
import Vue from "vue";

export default Vue.extend({
  name: "Column",
  inheritAttrs: false
});
